import { useState } from 'react';
import { getDynamicEnvVarsInClient } from '@/utils/envHelper';
import axios from 'axios';
import { toast } from 'sonner';

const useOtpVerify = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<string>('');

  const clientId =
    typeof window !== 'undefined'
      ? window.sessionStorage.getItem('clientId')
      : null;

  const { NEXT_PUBLIC_API_URL } = getDynamicEnvVarsInClient();

  const handleClick = async (
    email: string,
    tenantId: string,
    otp: string,
    secondary_user_id?: string | null,
    isCheckedNewsletter?: boolean,
    app_id?: string
  ) => {
    if (email && tenantId && otp && clientId) {
      setError('');
      setLoading(true);
      try {
        const url = NEXT_PUBLIC_API_URL;
        const res = await axios.post(`${url}/verify-otp`, {
          email: email?.toLowerCase(),
          tenantId,
          otp,
          clientId,
          ...(secondary_user_id ? { secondary_user_id } : {}),
          ...(isCheckedNewsletter
            ? { newsletter: true }
            : { newsletter: false }),
          ...(app_id ? { app_id } : {}),
        });
        if (res.data) {
          setData(res.data);
        }
      } catch (error: any) {
        const axiosError = error;
        if (axiosError?.response) {
          setError(axiosError?.response?.data?.message || 'An error occurred');
        } else if (axiosError?.request) {
          setError('Request failed, please try again later');
        } else {
          setError('An error occurred, please try again later');
        }
      } finally {
        setLoading(false);
      }
    } else {
      toast.error('Email, Tenant id, Client id and OTP must be specified');
    }
  };

  return {
    loading,
    handleClick,
    data,
    error,
  };
};

export default useOtpVerify;
